import { Box, Icon, Typography } from '@mui/material'
import Drawer from '@mui/material/Drawer'

const AdxDrawerComponent = ({
  state,
  onClose,
  anchor,
  title,
  headerprops,
  footerprops,
  children,
  sx,
  sxHeader,
  sxFooter,
  sxIcon,
  noPaddingContent,
}) => {
  const content = () => (
    <Box
      width={{ xs: '100vw', lg: 700 }}
      sx={{ ...sx }}
      boxSizing="border-box"
      className="scrollbar"
    >
      {headerprops ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            p: 3,
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
            position: 'sticky',
            top: 0,
            zIndex: 10,
            bgcolor: 'white.main',
            width: 1,
            ...sxHeader,
          }}
        >
          {title ? <Typography fontWeight="bold">{title}</Typography> : headerprops}
          <Icon
            onClick={onClose(anchor, false)}
            sx={{
              fontSize: 20,
              cursor: 'pointer',
              ...sxIcon,
            }}
          >
            close
          </Icon>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'end',
            p: 3,
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
            position: 'sticky',
            top: 0,
            zIndex: 10,
            bgcolor: 'white.main',
            ...sxHeader,
          }}
        >
          <Icon
            onClick={onClose(anchor, false)}
            sx={{
              fontSize: 20,
              cursor: 'pointer',
              '&:hover': {
                color: 'error.main',
              },
              ...sxIcon,
            }}
          >
            close
          </Icon>
        </Box>
      )}

      <Box sx={{ p: noPaddingContent ? 0 : 3, pb: footerprops ? 15 : 3 }}>{children}</Box>

      {footerprops && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 3,
            borderTop: '1px solid',
            borderColor: 'gray-line.main',
            position: 'absolute',
            bottom: 0,
            zIndex: 10,
            bgcolor: 'primary.light',
            width: '100%',
            ...sxFooter,
          }}
        >
          {footerprops}
        </Box>
      )}
    </Box>
  )

  return (
    <Drawer
      anchor={anchor}
      open={!!state?.[anchor]}
      onClose={onClose(anchor, false)}
      ModalProps={{ keepMounted: true }}
    >
      {content()}
    </Drawer>
  )
}

export default AdxDrawerComponent
